// extracted by mini-css-extract-plugin
export default {"container":"_1mLqz","betSlipContent":"TFHKt","backdrop":"bgGdJ","emptyBetSlip":"-v8Ah","footer":"_1Qd6u","bigStake":"_3nLev","scrollbarBetSlip":"fdfZ5"};